<template>
  <section class="section">
    <div class="container is-fluid">

      <h1 class="title is-3 has-text-danger">
        🔥 บทความและรายงานเกี่ยวกับไฟป่า
      </h1>

      <div class="columns is-multiline mt-4">

        <!-- Article 1 -->
        <div class="column is-6">
          <div class="card">
            <div class="card-content">
              <p class="title is-5">
                แนวโน้มไฟป่าโลกและผลกระทบต่อสภาพภูมิอากาศ
              </p>
              <div class="content">
                รายงานจาก NASA ระบุว่าไฟป่ามีบทบาทสำคัญต่อการปล่อยก๊าซเรือนกระจก
                โดยเฉพาะ CO₂ และ Black Carbon ซึ่งส่งผลต่อภาวะโลกร้อนและคุณภาพอากาศ
                การใช้ข้อมูลจากดาวเทียมช่วยให้สามารถติดตาม hotspot แบบ near real-time ได้
                และสนับสนุนการวางแผนจัดการภัยพิบัติได้อย่างมีประสิทธิภาพ
                <br><br>
                <strong>อ้างอิง:</strong> NASA Earth Observatory
              </div>
              <span class="tag is-danger is-light">Climate Impact</span>
            </div>
          </div>
        </div>

        <!-- Article 2 -->
        <div class="column is-6">
          <div class="card">
            <div class="card-content">
              <p class="title is-5">
                ผลกระทบของไฟป่าต่อสุขภาพประชาชน
              </p>
              <div class="content">
                องค์การอนามัยโลกระบุว่า ควันไฟป่ามีสาร PM2.5 และสารพิษที่ส่งผลต่อระบบทางเดินหายใจ
                และเพิ่มความเสี่ยงโรคหัวใจ โดยเฉพาะในเด็กและผู้สูงอายุ
                การติดตาม hotspot ช่วยเตือนภัยล่วงหน้าและลดความเสี่ยงต่อสุขภาพได้
                <br><br>
                <strong>อ้างอิง:</strong> World Health Organization (WHO)
              </div>
              <span class="tag is-warning is-light">Public Health</span>
            </div>
          </div>
        </div>

        <!-- Article 3 -->
        <div class="column is-6">
          <div class="card">
            <div class="card-content">
              <p class="title is-5">
                แนวทางจัดการไฟป่าในภูมิภาคเอเชียตะวันออกเฉียงใต้
              </p>
              <div class="content">
                รายงานจาก UNEP ชี้ให้เห็นว่าไฟป่าในภูมิภาคนี้ส่วนหนึ่งเกิดจากการเผาเพื่อการเกษตร
                และการเปลี่ยนแปลงการใช้ที่ดิน การบริหารจัดการแบบบูรณาการ
                และการใช้ข้อมูลดาวเทียมช่วยลดความรุนแรงของสถานการณ์ได้
                <br><br>
                <strong>อ้างอิง:</strong> United Nations Environment Programme
              </div>
              <span class="tag is-info is-light">Policy & Management</span>
            </div>
          </div>
        </div>

        <!-- Article 4 -->
        <div class="column is-6">
          <div class="card">
            <div class="card-content">
              <p class="title is-5">
                สถิติไฟป่าและการเปลี่ยนแปลงการใช้ที่ดิน
              </p>
              <div class="content">
                FAO รายงานว่าไฟป่าส่งผลกระทบต่อพื้นที่ป่าไม้หลายล้านเฮกตาร์ต่อปี
                โดยเฉพาะในประเทศกำลังพัฒนา การวิเคราะห์ข้อมูล hotspot
                ช่วยประเมินแนวโน้มและวางมาตรการฟื้นฟูพื้นที่ป่าได้อย่างแม่นยำ
                <br><br>
                <strong>อ้างอิง:</strong> Food and Agriculture Organization (FAO)
              </div>
              <span class="tag is-success is-light">Forestry</span>
            </div>
          </div>
        </div>

        <!-- Article 5 -->
        <div class="column is-12">
          <div class="card">
            <div class="card-content">
              <p class="title is-5">
                การติดตามจุดความร้อนในประเทศไทย
              </p>
              <div class="content">
                หน่วยงานด้านอวกาศของประเทศไทยใช้ข้อมูลจากดาวเทียม
                เพื่อตรวจจับ hotspot และรายงานสถานการณ์ไฟป่าในระดับจังหวัด
                ข้อมูลดังกล่าวสนับสนุนการตัดสินใจของหน่วยงานภาครัฐ
                และช่วยลดผลกระทบต่อประชาชนในพื้นที่เสี่ยง
                <br><br>
                <strong>อ้างอิง:</strong> GISTDA
              </div>
              <span class="tag is-primary is-light">Thailand Monitoring</span>
            </div>
          </div>
        </div>

      </div>

    </div>
  </section>
</template>

<script setup>
</script>